import React, { useEffect, useState } from "react"
import chunk from "lodash.chunk"

import useTracking from "hooks/useTracking"

import ArticleBatchScrollLoader from "components/article-batch-scroll-loader"
import { Grid2 } from "../grids"
import { Container, Title } from "./styles"

const MoreArticles = ({
  className,
  title = "",
  category = "",
  subcategory = "",
  articles,
  loadImmediately = false,
  pageType,
}) => {
  const { track } = useTracking()

  const titleText =
    title || (subcategory || category ? `more in ${(subcategory || category).toLowerCase()}` : "")

  const chunksPerBatch = 5
  const chunkLength = 9
  const [batches, setBatches] = useState([articles.slice(0, chunksPerBatch * chunkLength)])

  useEffect(() => {
    if (loadImmediately) {
      setBatches(chunk(articles, chunkLength))
    }
  }, [loadImmediately, articles, chunkLength])

  const hasMore = batches.length * chunksPerBatch * chunkLength < articles.length

  const handleViewMoreClick = () => {
    track("Element Clicked", {
      element_id: "view_more_articles",
      ...(category && { category }),
      ...(subcategory && { subcategory }),
    })

    setBatches((prev) => {
      const currentBatch = prev.length
      return [
        ...prev,
        articles.slice(
          currentBatch * chunksPerBatch * chunkLength,
          (currentBatch + 1) * chunksPerBatch * chunkLength,
        ),
      ]
    })
  }

  return (
    <Container className={className}>
      {titleText && <Title>{titleText}</Title>}
      {loadImmediately ? (
        batches.map((batch, i) => (
          <Grid2
            key={`more-articles-batch-${batch[0]?.id}`}
            id={`more-articles-batch-${batch[0]?.id}`}
            articles={batch}
            startIndex={i * chunkLength}
            pageType={pageType}
          />
        ))
      ) : (
        <ArticleBatchScrollLoader
          id="more-articles"
          batches={batches}
          chunksPerBatch={chunksPerBatch}
          chunkLength={chunkLength}
          gridComponent={Grid2}
          hasMore={hasMore}
          pageType={pageType}
          onViewMoreClick={handleViewMoreClick}
        />
      )}
    </Container>
  )
}

export default MoreArticles
